// extracted by mini-css-extract-plugin
export default {"productcard":"nJ","productimage":"oJ","username":"pJ","multiBagName":"qJ","productinfo":"rJ","productinfoinner":"sJ","productname":"tJ","productsubheader":"uJ","productdescription":"vJ","productnumbers":"wJ","productnumberstitle":"xJ","productnumbersitem":"yJ","number":"zJ","numbertext":"AJ","tabs":"BJ","benefitsblock":"CJ","benefit":"EJ","benefitname":"FJ","benefitdescription":"GJ","ingredientsblock":"HJ","tipsblock":"IJ","mobileonly":"JJ"};
    if(module.hot) {
      // 1715276858937
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  